import { Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { WRITE_ROLES, useAuth } from "../lib/auth";
import { fmtDateTime } from "../lib/format";
import { Button, Card } from "./ui";

export function AiSummary({ scope, keyValue }: { scope: "daily" | "monthly"; keyValue: string }) {
  const { can } = useAuth();
  const [d, setD] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setD(null); api.get("/ai/summary", { params: { scope, key: keyValue } }).then((r) => setD(r.data)).catch(() => setD({ text: null })); }, [scope, keyValue]);
  const gen = async () => {
    setBusy(true);
    try { const { data } = await api.post("/ai/summary", { scope, key: keyValue }); setD(data); toast.success("Ringkasan AI dibuat"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Card title="Ringkasan AI" subtitle={d?.text ? `Dibuat ${fmtDateTime(d.created_at)} oleh ${d.by}${scope === "daily" ? " · ikut tercetak di PDF tutup kas" : ""}` : "Narasi otomatis Bahasa Indonesia untuk manajemen"} testId={`ai-summary-${scope}`}
      action={can(WRITE_ROLES) && <Button size="sm" variant="outline" disabled={busy} onClick={gen} data-testid={`ai-summary-${scope}-generate`}><Sparkles className="h-4 w-4" /> {busy ? "Menyusun…" : d?.text ? "Perbarui" : "Buat ringkasan"}</Button>}>
      {d?.text ? <div className="text-sm whitespace-pre-wrap leading-relaxed" data-testid={`ai-summary-${scope}-text`}>{d.text}</div> : <p className="text-sm text-muted-foreground" data-testid={`ai-summary-${scope}-empty`}>{d === null ? "Memuat…" : "Belum ada ringkasan. Klik \"Buat ringkasan\" untuk menyusun narasi dari data periode ini."}</p>}
    </Card>
  );
}
